import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { StatusCuti } from 'src/app/constants/status-cuti';
import { ApprovalRequest } from 'src/app/models/approval-request.t';
import { DialogData } from 'src/app/models/dialog-data';
import { GeneralResponse } from 'src/app/models/general-response';
import { ApplicationService } from 'src/app/services/application.service';
import { CutiService } from 'src/app/services/cuti/cuti.service';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-approval',
  templateUrl: './approval.component.html',
  styleUrls: ['./approval.component.css']
})
export class ApprovalComponent implements OnInit {
  isLoading: boolean = false;

  @Input()
  cutiId: string = '';

  @Input()
  isPejabat: boolean = false;

  constructor(
    public dialog: MatDialog,
    private cutiService: CutiService,
    private applicationService: ApplicationService,
  ) { }

  ngOnInit(): void {
  }

  approve() {
    this.approval(true);
  }

  reject() {
    this.approval(false);
  }

  approval(isApprove: boolean) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Peringatan',
        message: `Apakah Anda yakin akan ${isApprove ? 'menyetujui' : 'menolak'} pengajuan ini?`,
        isConfirmation: true,
        addRemark: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        this.isLoading = true;
        let status = 0;
        if (this.isPejabat) {
          status = isApprove ? StatusCuti.DISETUJUI_PEJABAT : StatusCuti.TIDAK_DISETUJUI_PEJABAT;
        } else {
          status = isApprove ? StatusCuti.DISETUJUI_ATASAN : StatusCuti.TIDAK_DISETUJUI_ATASAN;
        }
        const data: ApprovalRequest = {
          id: this.cutiId,
          note: result.remark,
          status: status,
        };

        const request$: Observable<GeneralResponse> = this.isPejabat ? this.cutiService.approvePejabat(data) : this.cutiService.approveAtasan(data);
        request$.subscribe(() => {
          this.isLoading = false;
          this.applicationService.reload$.next(true);
        });
      }
    });
  }

}
